export const FETCH_ASSETS_REQUEST = '@@assets/FETCH_ASSETS_REQUEST';
export const FETCH_ASSETS_SUCCESS = '@@assets/FETCH_ASSETS_SUCCESS';
export const FETCH_ASSETS_FAILURE = '@@assets/FETCH_ASSETS_FAILURE';

export const LOAD_MORE_ASSETS_REQUEST = '@@assets/LOAD_MORE_ASSETS_REQUEST';
export const LOAD_MORE_ASSETS_SUCCESS = '@@assets/LOAD_MORE_ASSETS_SUCCESS';
export const LOAD_MORE_ASSETS_FAILURE = '@@assets/LOAD_MORE_ASSETS_FAILURE';

export const MOVE_ASSET_REQUEST = '@@assets/MOVE_ASSET_REQUEST';
export const MOVE_ASSET_SUCCESS = '@@assets/MOVE_ASSET_SUCCESS';
export const MOVE_ASSET_FAILURE = '@@assets/MOVE_ASSET_FAILURE';

export const NEW_ASSET_REQUEST = '@@assets/NEW_ASSET_REQUEST';
export const NEW_ASSET_CLEAR_ERROR = '@@assets/NEW_ASSET_CLEAR_ERROR';
export const NEW_ASSET_SUCCESS = '@@assets/NEW_ASSET_SUCCESS';
export const NEW_ASSET_FAILURE = '@@assets/NEW_ASSET_FAILURE';

export const UPDATE_ASSET_REQUEST = '@@assets/UPDATE_ASSET_REQUEST';
export const UPDATE_ASSET_SUCCESS = '@@assets/UPDATE_ASSET_SUCCESS';
export const UPDATE_ASSET_FAILURE = '@@assets/UPDATE_ASSET_FAILURE';

export const DELETE_ASSET_REQUEST = '@@assets/DELETE_ASSET_REQUEST';
export const DELETE_ASSET_SUCCESS = '@@assets/DELETE_ASSET_SUCCESS';
export const DELETE_ASSET_FAILURE = '@@assets/DELETE_ASSET_FAILURE';

export const PUBLISH_ASSET_REQUEST = '@@assets/PUBLISH_ASSET_REQUEST';
export const PUBLISH_ASSET_SUCCESS = '@@assets/PUBLISH_ASSET_SUCCESS';
export const PUBLISH_ASSET_FAILURE = '@@assets/PUBLISH_ASSET_FAILURE';

export const SET_ASSET_ORDER = '@@assets/SET_ASSET_ORDER';
export const SET_ASSET_ORDER_DIRECTION = '@@assets/SET_ASSET_ORDER_DIRECTION';

export const SET_ASSET_SEARCH_TERM = '@@assets/SET_ASSET_SEARCH_TERM';
export const SET_ASSET_SEARCH_SELECTED_TAGS = '@@assets/SET_ASSET_SEARCH_SELECTED_TAGS';

// Batch action constants
export const DUPLICATE_ASSETS_REQUEST = '@@assets/DUPLICATE_ASSETS_REQUEST';
export const DUPLICATE_ASSETS_SUCCESS = '@@assets/DUPLICATE_ASSETS_SUCCESS';
export const DUPLICATE_ASSETS_FAILURE = '@@assets/DUPLICATE_ASSETS_FAILURE';

export const MOVE_ASSETS_REQUEST = '@@assets/MOVE_ASSETS_REQUEST';
export const MOVE_ASSETS_SUCCESS = '@@assets/MOVE_ASSETS_SUCCESS';
export const MOVE_ASSETS_FAILURE = '@@assets/MOVE_ASSETS_FAILURE';

export const COPY_ASSETS_REQUEST = '@@assets/COPY_ASSETS_REQUEST';
export const COPY_ASSETS_SUCCESS = '@@assets/COPY_ASSETS_SUCCESS';
export const COPY_ASSETS_FAILURE = '@@assets/COPY_ASSETS_FAILURE';

export const DOWNLOAD_ASSETS_REQUEST = '@@assets/DOWNLOAD_ASSETS_REQUEST';
export const DOWNLOAD_ASSETS_SUCCESS = '@@assets/DOWNLOAD_ASSETS_SUCCESS';
export const DOWNLOAD_ASSETS_FAILURE = '@@assets/DOWNLOAD_ASSETS_FAILURE';

export const PUBLISH_ASSETS_REQUEST = '@@assets/PUBLISH_ASSETS_REQUEST';
export const PUBLISH_ASSETS_SUCCESS = '@@assets/PUBLISH_ASSETS_SUCCESS';
export const PUBLISH_ASSETS_FAILURE = '@@assets/PUBLISH_ASSETS_FAILURE';

export const DELETE_ASSETS_REQUEST = '@@assets/DELETE_ASSETS_REQUEST';
export const DELETE_ASSETS_SUCCESS = '@@assets/DELETE_ASSETS_SUCCESS';
export const DELETE_ASSETS_FAILURE = '@@assets/DELETE_ASSETS_FAILURE';

export const TAG_ASSETS_REQUEST = '@@assets/TAG_ASSETS_REQUEST';
export const TAG_ASSETS_SUCCESS = '@@assets/TAG_ASSETS_SUCCESS';
export const TAG_ASSETS_FAILURE = '@@assets/TAG_ASSETS_FAILURE';

// export project images (tables/charts -> PNG)
export const EXPORT_PROJECT_IMAGES_REQUEST = '@@assets/EXPORT_PROJECT_IMAGES_REQUEST';
export const EXPORT_PROJECT_IMAGES_SUCCESS = '@@assets/EXPORT_PROJECT_IMAGES_SUCCESS';
export const EXPORT_PROJECT_IMAGES_FAILURE = '@@assets/EXPORT_PROJECT_IMAGES_FAILURE';


// WEBPACK FOOTER //
// ./src/constants/assets.js